import React from "react";
import { PiUserGearLight, PiUserPlusLight } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { cssProperties } from "../../utils/commonCssProperties";

export default function Index() {

  const navigate = useNavigate();

  const items = [
    { icon: <PiUserPlusLight size={30} />, name: "MASTER MANAGEMENT", details: "(Create new masters for a project)", path: `/${Cookies.get('mhet_mst_project')}/master-list` },
    { icon: <PiUserPlusLight size={30} />, name: "MASTER FORMS MANAGEMENT", details: "(Create new masters forms)", path: `/${Cookies.get('mhet_mst_project')}/master-forms-list` },
    { icon: <PiUserPlusLight size={30} />, name: "COURSE MASTER MANAGEMENT", details: "(Create new course for a projects)", path: `/${Cookies.get('mhet_mst_project')}/course-management?page=courselist` },
    { icon: <PiUserPlusLight size={30} />, name: "CANDIDATE MANAGEMENT", details: "(Option to Update Four Fields)", path: `/${Cookies.get('mhet_mst_project')}/candidate-management?page=searchcandidate` },
    { icon: <PiUserPlusLight size={30} />, name: "OTBS MANAGEMENT", details: "(Adding Venue data for OTBS)", path: `/${Cookies.get('mhet_mst_project')}/otbs-management` },
    { icon: <PiUserGearLight size={30} />, name: "Allocate Venue", details: "(Enable venue data,candidate data and allocate venue)", path: `/${Cookies.get('mhet_mst_project')}/allocate-venue` },
    { icon: <PiUserPlusLight size={30} />, name: "Force Push", details: "(Allocate venue to candidate manually)", path: `/${Cookies.get('mhet_mst_project')}/force-push` },
    { icon: <PiUserPlusLight size={30} />, name: "Roll No Management", details: "(Generate Roll Number)", path: `/${Cookies.get('mhet_mst_project')}/roll-no-management` },
    { icon: <PiUserPlusLight size={30} />, name: "Admit Card Generator", details: "(Generate AdmitCard)", path: `/${Cookies.get('mhet_mst_project')}/admit-card-generator` },
    { icon: <PiUserPlusLight size={30} />, name: "External Admit Card Generator", details: "(Generate AdmitCard)", path: `/${Cookies.get('mhet_mst_project')}/external-admit-card-generator` },
    { icon: <PiUserPlusLight size={30} />, name: "ScoreCard", details: "(Generate ScoreCard)", path: `/${Cookies.get('mhet_mst_project')}/score-card` },
    { icon: <PiUserPlusLight size={30} />, name: "ELIGIBILITY CRITERIA MANAGEMENT", details: "(Create new Eligibility Criteria Config Name)", path: `/${Cookies.get('mhet_mst_project')}/eligibility-management?page=eligibilitycriteria` },
    { icon: <PiUserPlusLight size={30} />, name: "REFUND MANAGEMENT", details: "(Candidate Refund)", path: `/${Cookies.get('mhet_mst_project')}/candidate-refund` },
    { icon: <PiUserPlusLight size={30} />, name: "OBJECTION MANAGEMENT", details: "(Create Objection for a projects)", path: `/${Cookies.get('mhet_mst_project')}/objection-management?page=objectionlist` },



  ]

  return (
    <Grid container spacing={3} sx={{ marginTop: '12px', justifyContent: 'center' }}>
      {items.map((item, index) => (
        <Grid item xs={12} sm={6} lg={4} key={index}
          display="flex" justifyContent="center"
          onClick={() => {
            if (item?.path) {
              navigate(item.path);
            }
          }}
        >
          <Card
            sx={{
              width: '100%',
              height: '227px',
              borderRadius: "8px",
              cursor: 'pointer',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: "none"
            }}
          >
            <Box
              sx={{
                backgroundColor: `${cssProperties?.backgroundcolor?.secondary}`,
                color: `${cssProperties?.color?.textsecondary}`,
                border: `1px solid ${cssProperties?.bordercolor?.primary}`,
                borderRadius: '50%',
                width: '62px',
                height: '62px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: '12px'
              }}
            >
              {item.icon}
            </Box>
            <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px' }}>
              <Typography
                variant="h6"
                component="div"
                sx={{
                  fontSize: 16,
                  fontWeight: 700,
                  color: `${cssProperties?.fontcolor?.tableblack}`,
                  textAlign: 'center'
                }}
              >
                {item.name}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: 12,
                  fontWeight: 500,
                  color: `${cssProperties?.color?.textsecondary}`,
                  textAlign: 'center',
                }}
              >
                {item.details}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
